import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function TaglessIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "primary";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          color={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="Tagless" fill="none">
          <path
              fill="#0E893C"
              fillRule="evenodd"
              d="M6.81 2.5a1.499 1.499 0 0 0-1.423 1.017l-1.75 3.898a.75.75 0 0 1-1.368-.614l1.74-3.878A2.999 2.999 0 0 1 6.812 1h8.881c1.243 0 2.357.765 2.803 1.923l-.01-.02-.684.307.703-.264a14.837 14.837 0 0 0-.01-.023l1.742 3.88a.75.75 0 1 1-1.369.614l-1.75-3.9A1.501 1.501 0 0 0 15.694 2.5H6.81ZM1.502 12.8a.75.75 0 0 1 .75.75v1.7a.75.75 0 1 0 1.5 0v-1.5a.75.75 0 0 1 1.5 0v1.5a2.25 2.25 0 1 1-4.5 0v-1.7a.75.75 0 0 1 .75-.75ZM3.002 10.375c0-.621.504-1.125 1.125-1.125a.75.75 0 0 1 .309 1.434.75.75 0 0 1-1.434-.309Z"
              clipRule="evenodd"
          />
          <path
              fill="#0E893C"
              fillRule="evenodd"
              d="M3.377 10a.75.75 0 0 1 .75-.75c.621 0 1.125.504 1.125 1.125a.75.75 0 0 1-1.434.309.75.75 0 0 1-.441-.684Z"
              clipRule="evenodd"
          />
          <path
              fill="#0E893C"
              fillRule="evenodd"
              d="M4.502 9.625a.75.75 0 0 1 .75.75c0 .621-.504 1.125-1.125 1.125a.75.75 0 0 1-.309-1.434.75.75 0 0 1 .684-.441Z"
              clipRule="evenodd"
          />
          <path
              fill="#0E893C"
              fillRule="evenodd"
              d="M4.436 10.066a.75.75 0 0 0-1.434.309c0 .621.504 1.125 1.125 1.125a.75.75 0 0 0 .309-1.434Z"
              clipRule="evenodd"
          />
          <path
              fill="#0E893C"
              fillRule="evenodd"
              d="M18.75 6.25c1.34 0 2.58.714 3.25 1.875a.75.75 0 0 1-1.3.75 2.25 2.25 0 0 0-1.95-1.125h-15A2.25 2.25 0 0 0 1.5 10v2.25c0 .414.336.75.75.75h6a.75.75 0 0 1 0 1.5h-6A2.25 2.25 0 0 1 0 12.25V10a3.75 3.75 0 0 1 3.75-3.75h15Z"
              clipRule="evenodd"
          />
          <path
              fill="#0E893C"
              fillRule="evenodd"
              d="M10.502 16.75a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0Zm6.75-5.25a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Z"
              clipRule="evenodd"
          />
          <path
              fill="#0E893C"
              fillRule="evenodd"
              d="M20.377 14.405a.75.75 0 0 1 .15 1.05l-2.905 3.874a1.503 1.503 0 0 1-2.261.16l-1.5-1.5a.75.75 0 0 1 1.06-1.06l1.5 1.5h.001l2.905-3.874a.75.75 0 0 1 1.05-.15Z"
              clipRule="evenodd"
          />
      </SvgIcon>
  );
}
